import {PaymentMethodCategoryEnum} from "../payment-method-category.enum";
import {AlternativePaymentMethodModel} from "../alternative-payment-method.model";
import {IPaypalPaymentMethodViewModel} from "./paypal-payment-method.view-model.interface";
import {
    PaymentSupportedOS,
    PaymentSupportedPlatformTypes
} from "../../../../../configuration/objects/payments-configuration.interface";
import React from "react";
import {
    PaypalPaymentMethodTabHeaderComponent
} from "../../../../../../pages/booking-flow/payment/paypal/paypal-payment-method-tab-header.component";
import {
    PaypalPaymentMethodTabContentComponent
} from "../../../../../../pages/booking-flow/payment/paypal/paypal-payment-method-tab-content.component";
import {PaypalButtonComponent} from "../../../../../../pages/booking-flow/payment/paypal/paypal-button.component";

export class PaypalPaymentMethodModel extends AlternativePaymentMethodModel implements IPaypalPaymentMethodViewModel {

    get name(): string {
        return "PayPal";
    }

    protected _getSupportedOS(): PaymentSupportedOS {
        return ['all'];
    }

    protected _getSupportedPlatformsTypes(): PaymentSupportedPlatformTypes {
        return ['all'];
    }

    protected async _canMakePayments(): Promise<boolean> {
        return Boolean(this.services.configuration.data.pspConfigs?.PayPal?.clientId);
    }

    get category(): PaymentMethodCategoryEnum {
        return PaymentMethodCategoryEnum.AlternativePaymentMethod;
    }


    async startOrder(): Promise<string> {
        const result = await this.booking.paymentHandler.startBookingPayment({
            paymentMethodCode: this.code
        });
        return result.pspOrderToken ?? "";
    }

    async finalizeOrder(): Promise<void> {
        await this.booking.paymentHandler.finalizePspOrder();
    }

    async cancelOrder(): Promise<void> {
        await this.booking.paymentHandler.cancelPspOrder()
    }

    renderTabHeader(): React.ReactElement {
        return (
            <PaypalPaymentMethodTabHeaderComponent/>
        );
    }

    renderTabContent(): React.ReactElement {
        return (
            <PaypalPaymentMethodTabContentComponent />
        )
    }

    renderPayButton(): React.ReactElement {
        return (
            <PaypalButtonComponent payPalMethod={this}/>
        );
    }
}